import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../common/utils/stimulus"

class Turnstile extends Controller {
  static targets = [`container`]
  static values = { sitekey: String }

  connect() {
    this.turnstileId = window.turnstile.render(this.containerTarget, {
      sitekey: this.sitekeyValue,
      theme: `light`,
    })
  }

  disconnect() {
    window.turnstile.remove(this.turnstileId)
  }
}

Stimulus.register(`turnstile`, Turnstile)
